import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../assets/css/SliderHome.css';

const SliderHome = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(
          'https://www.startupbusinesspartners.com/api/banners',
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }
        );
        
        if (response.data.success) {
          // Map API data to slider format
          const formattedSlides = response.data.data.map(banner => ({
            id: `banner-${banner.id}`,
            bgImage: `https://www.startupbusinesspartners.com/uploads/cms/${banner.bgImage}`,
            title: (
              <>
                {banner.title.split('<br>').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < banner.title.split('<br>').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </>
            ),
            description: banner.description || (
              <>
                Startup Business is one of the world's top business consulting firms. <br />
                We help global leaders with their issues.
              </>
            ),
            link: banner.link || '#',
            transition: banner.position === 'top' ? 'boxslide' : 'slotzoom-horizontal'
          }));
          
          setSlides(formattedSlides);
        } else {
          throw new Error(response.data.message || 'Failed to fetch banners');
        }
      } catch (err) {
        setError(err.message);
        console.error('Error fetching banners:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // Auto-slide every 8.5 seconds
  useEffect(() => {
    if (slides.length > 1) {
      const timer = setInterval(() => {
        setActiveSlide((prev) => (prev + 1) % slides.length);
      }, 8500);
      return () => clearInterval(timer);
    }
  }, [slides.length]);

  if (loading) {
    return (
      <div className="slider-loading" style={{ 
        height: '600px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <p>Loading banners...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="slider-error" style={{ 
        height: '600px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        color: 'red'
      }}>
        <p>Error loading banners: {error}</p>
      </div>
    );
  }

  if (slides.length === 0) {
    return (
      <div className="slider-empty" style={{ 
        height: '600px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <p>No active banners available</p>
      </div>
    );
  }

  return (
    <div
      className="rev_slider_wrapper fullwidthbanner-container"
      data-alias="slider4"
      data-source="gallery"
      style={{ margin: '0 auto', background: 'transparent', padding: 0 }}
    >
      <div className="rev_slider fullwidthabanner">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === activeSlide ? 'active' : ''}`}
     style={{
  backgroundImage: `url(${slide.bgImage})`,
  display: index === activeSlide ? 'block' : 'none',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '600px' // Adjust as needed
}}

          >
            <div className="rev_row_zone rev_row_zone_middle" style={{ zIndex: 5 }}>
              <div className="slide-content">
                <div className="tp-caption" style={{ zIndex: 5 }}>
                  <div className="column left" style={{ width: '16.67%' }}></div>
                  <div className="column center" style={{ width: '66.67%', textAlign: 'center' }}>
                    <h2
                      className="tp-caption tp-resizeme title"
                      style={{
                        zIndex: 8,
                        whiteSpace: 'normal',
                        fontSize: '60px',
                        lineHeight: '72px',
                        fontWeight: 600,
                        color: '#ffffff',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                      }}
                    >
                      {slide.title}
                    </h2>
                    <p
                      className="tp-caption tp-resizeme description"
                      style={{
                        zIndex: 9,
                        whiteSpace: 'normal',
                        fontSize: '20px',
                        lineHeight: '36px',
                        fontWeight: 400,
                        color: '#ffffff',
                        marginTop: '30px',
                        marginBottom: '35px',
                        textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                      }}
                    >
                      {slide.description}
                    </p>
                    <div className="button-group">
                      <a
                        href={slide.link}
                        className="tp-caption btn btn--rounded btn-secondary"
                        style={{ zIndex: 11, display: 'inline-block' }}
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                  <div className="column right" style={{ width: '16.67%' }}></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SliderHome;